import React, {useRef, useState, useEffect} from 'react'
import { FaFilePdf } from "react-icons/fa";
import { useUploadFile, useCreateReplace } from '../hooks/mutations';
import { v4 as uuidv4 } from 'uuid'; 
import { keyId, addLogToDoc, addValueAndValueForDropdown, sortByLabel, unique, successAlert } from '../lib/utils';

import { AddButton, TextField, VisDiv } from '../components';
import {FieldDropdown} from '../components';
import { useAuthContext } from '../hooks/useAuthContext';
import { useStateContext } from '../context/StateContext';
import { useQuery } from '@tanstack/react-query';
import { _FETCH } from '../lib/patches';
import {Loading} from '../components';
import { referenceDoc } from '../components/gestioneDatabase/Docs';
import FieldDropdownFree from '../components/FieldDropdownFree';
import NoAccessMessage from '../components/NoAccessMessage';
import { pdfQuery, singleListQuery } from '../lib/data';
import { PdfDocumentPin } from '../components/PdfDocumentPin';
import { errorAlert } from '../lib/utils';

const PdfFilesManagement = ({isLoaded = false, addPdfToComment, clientDetails={}, pdfs =[], setPdfs=()=>{}}) => {
   const {apiUrl, sUser} = useStateContext()
   const fetchRoute = `${apiUrl}/calls/fetch-docs`
   const {user} = useAuthContext()


/*   const filterOutLists = ["MOTIVO SOSTITUZIONE", "FLOORS", "AMBIENTE/LUOGO", "ANNI", "AREE", "PIANI", "SERVE CHIAVE"]
  const {data: lists, isLoading: listsLoading} = useQuery(['lists'], ()=> _FETCH({route: fetchRoute, user, query: `*[_type == "list" && !(listName in ["${filterOutLists.join('","')}"])]{...,"fieldList":fieldList[]->}`}),{
    onError:(error)=>{console.log("nonConformities", error)},
    enabled: isLoaded,
    staleTime: 1000 * 60 * 60,
  }) */
/*   const {data: templateRegistersData, isLoading: templateRegistersLoading} = useQuery(['templateRegisters'], ()=> _FETCH({route: fetchRoute, user, query: '*[_type == "registerTemplates"]'}),{
    onError:(error)=>{console.log("nonConformities", error)},
    enabled: isLoaded,
    staleTime: 1000 * 60 * 60,
  }) */
  const {data: pdfCategoriesList, isLoading: pdfCategoriesListLoading} = useQuery(['pdfCategoriesList'], ()=> _FETCH({route: fetchRoute, user, query: singleListQuery("f30830aa-317f-478b-9b98-8ba0e8fca2fc")}),{
    onError:(error)=>{console.log("nonConformities", error)},
    onSuccess:(data)=> {console.log("pdfCategoriesList", data)},
    enabled: isLoaded,
    staleTime: 1000 * 60 * 60,
  })
  
/*   const {data: presidioModulesData, isLoading: presidioModulesLoading} = useQuery(['presidioModules'], ()=> _FETCH({route: fetchRoute, user, query: '*[_type == "presidioModule"]'}),{
    onError:(error)=>{console.log("nonConformities", error)},
    enabled: isLoaded,
    staleTime: 1000 * 60 * 60,
  }) */

/*   const {data: clients, isLoading: clientsLoading} = useQuery(['clients'], ()=> _FETCH({route: fetchRoute, user, query: '*[_type == "client"]'}),{
    onError:(error)=>{console.log("nonConformities", error)},
    enabled: isLoaded,
    staleTime: 1000 * 60 * 60,
  }) */

  const [categoryFilter, setCategoryFilter] = useState()


    const {data: pdfData, isLoading: pdfDataLoading} = useQuery(['pdfs', categoryFilter], ()=> _FETCH({route: fetchRoute, user, query: pdfQuery(categoryFilter?._id)}),{
        onError:(error)=>{
          console.log("pdfs not loaded", error)
          errorAlert("ERRORE, IMPOSSIBILE CARICARE PDFS")
        },
        onSuccess:(data)=> {
          console.log("data loaded", data, categoryFilter?._id)
        },
        enabled: !!categoryFilter,
    }) 


  const loadingQueries = [
    //clientsLoading,
    //templateRegistersLoading,
   // presidioModulesLoading,
    //listsLoading,
    pdfCategoriesListLoading
  ]
  const pdfCategories = pdfCategoriesList?.fieldList

  const isQueriesLoading = loadingQueries?.some?.((x)=>x==true)



    const [idAndKey, setIdAndKey] = useState({ _id: uuidv4(), _key: keyId(),})
    const [categories, setCategories] = useState([])
    const [tags, setTags] = useState([])
    const [templateRegisters, setTemplateRegisters] = useState([])
    const [deviceTemplates, setDeviceTemplates] = useState([])
    const [title, setTitle] = useState("")
    const [file, setFile] = useState({})

    const [viewEdit, setViewEdit] = useState(false)

    const hiddenFileInput = useRef(undefined);  
    const resetDoc = () => {
      setIdAndKey({ _id: uuidv4(), _key: keyId(),})
      setCategories([])
      setTags([])
      setTemplateRegisters([])
      setDeviceTemplates([])
      setTitle("")
      setFile({})
    }

    const pdfDoc = {
        _type:"pdf",
        ...idAndKey?._id ? idAndKey : {},
        deviceId: clientDetails?.deviceId,
        registerId: clientDetails?.registerId,
        siteId: clientDetails?.siteId,
        clientId: clientDetails?.clientId,
        categories: categories?.map?.((x)=>referenceDoc(x?._id)),
        devices: deviceTemplates?.map?.((x)=>referenceDoc(x?._id)),
        templates: templateRegisters?.map?.((x)=>referenceDoc(x?._id)),
        tags: tags?.map?.((x)=>x?.label),
        title: title,
        file: file,
    }
    const {mutate: updateDocument} = useCreateReplace({
/*         onMutate: async (newDoc) => {

            await queryClient.cancelQueries({ queryKey: ['customerProducts'] })
            const previousData = queryClient.getQueryData(['customerProducts'])
       
            //const doc = newDoc?.doc
            
            queryClient.setQueryData(['customerProducts'], (old) =>{ 
                const doc = newDoc?.doc
                const oldData = old?.length > 0 ? old : []
                const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
                return newData
            })
            return {previousData}
        }, */

        onError: (err, newDoc, context) => {
            console.error('Oh no, the update failed: ', err?.message)
            errorAlert("ERRORE; Il documento non è stato modificato Ricarica la pagina")
            
            //queryClient.setQueryData(['customerProducts'], context?.previousData)

        }
        })

    // find presdio modules in selected registers
      const registersPresidioModulesRefs = templateRegisters?.map?.((item) => {
        return  item?.devices?.map?.((x=>x?._ref))
    })?.flat()
    const uniquePresidioModulesRefs = [...new Set(registersPresidioModulesRefs)];
    
    //const presidioModulesOptions =!Array.isArray(presidioModulesData) ? [] : presidioModulesData?.filter?.((x)=>uniquePresidioModulesRefs?.includes(x?._id))

    // tags options from deviceProperty types in lists
/*     const tagsOptions = unique("label",lists?.map?.((list)=>{
      return list?.fieldList?.map?.((item)=>{
        return ( {label:item?.label, value: item?.label} )
      })
    })?.flat()) */

    const {mutate: uploadPdf} = useUploadFile({
        onError:()=>{
            errorAlert("UPLOAD FOTO NON RIUSCITO")
          } 
      })
      const handleClick = event => {
        hiddenFileInput.current.click();
      };
    const uploadPdfFile = (data) => {
        const selectedFile = data.target.files[0];
        if(selectedFile?.type == "application/pdf"){
          const fileAsset = {fileType:"file",file: selectedFile}
          console.log("UPLOAD PDF FILE", fileAsset)
          uploadPdf(fileAsset,{
            onSuccess:(asset)=>{
            const sanityPDFDoc = {
                _type: 'file',
                _key: keyId(),
                asset: {
                    _type: 'reference',
                    _ref: asset?._id,
                    _key: keyId()
                  },
                
              }
              setFile(sanityPDFDoc)
              if(!title){
                setTitle(fileAsset?.file?.name)
              }
          }
            })
         
        }  else {
          errorAlert("IL FILE SELEZIONATO NON E' UN PDF")
        }   
      }
      const savePdf = () => {
        updateDocument({doc: pdfDoc},{
          onSuccess: () => {
       
            if(addPdfToComment) {
              console.log("ADDING URL", file)
              const match = file?.asset?._ref?.match(/file-([a-f0-9]{40})-pdf/);
              const projectId = process.env.NEXT_PUBLIC_PROJECT_ID
              const buildUrl = `https://cdn.sanity.io/files/${projectId}/production/${match?.[1]}.pdf`
              const commentPdf = {title: pdfDoc?.title, url: buildUrl, pdfId: pdfDoc?._id, file: pdfDoc?.file}
              if(match?.[1]) {
                setPdfs([...pdfs, commentPdf])
              }
              else {
                errorAlert("IL PDF E' STATO CARICATO MA NON E' STATO POSSIBILE AGGIUNGERLO AL COMMENTO. CARICA I PDF E AGGIUNGILO")
              }
     
            }
            successAlert("PDF AGGIUNTO CON SUCCESSO")
            resetDoc()
          }
        }
        )
      }

      const updatePdfs = (data) => {
        setPdfs(data)
        console.log("UPDATE PDFS", data)
      }
      const deleteFn = (data) => {
        console.log("DELETE PDF", data)
      }

      // Using useEffect to throw error in render phase
      const [shouldError, setShouldError] = useState(false);
      useEffect(() => {
        if (shouldError) {
          throw new Error('Application error: a client side exception');
        }
      }, [shouldError]);

      const testFunction = () => {
        //setShouldError(true);
        console.log("ewdhbwelukdfghb",{pdfDoc, pdfCategories})

      }

  if(sUser?.userType !== "God Mode" && sUser?.userType !== "Admin"){
        return <NoAccessMessage/>  
    } 

  if (isQueriesLoading) { return <Loading/> }

    
  return (
    <div className='new-device-container-top'>
      <button onClick={testFunction}>test docs management</button>
      <FieldDropdown
          isSearchable="isSearchable"
          placeHolder={"Seleziona pdf esistenti"}
          options={pdfCategories}
          initialValue={categoryFilter}
          onChange={(value) => { 
              setCategoryFilter(value)
          }}
      />
      <VisDiv rules={[pdfData?.length > 0]}>
          {!Array.isArray(pdfData) ? [] : pdfData?.filter?.((x)=>x?.status !== "ARCHIVIATO")?.map?.((item)=>{
                const handleClick = () => {
                  window.open(item?.url, "_blank")
                  console.log("lwaebnflwjeHBFN", item)
              }
              return (
                  <PdfDocumentPin 
                    addPdfToComment = {addPdfToComment}
                    //pdfManagement={pdfManagement}
                    //hideViewer={hideViewer} 
                    //hideAddPdfButton={hideAddPdfButton} 
                    hideDeletePdfButton={addPdfToComment} 
                    clickTitle={handleClick} 
                    key={item?._id} 
                    pdf={item} 
                    pdfs={pdfs} 
                    setPdfs={setPdfs} 
                    pdfUrl={item?.url} 
                    deleteFn={deleteFn}/>
              )
          })}

      </VisDiv>
    {/*   <AddButton onClick={()=>setViewEdit(!viewEdit)} label={viewEdit ? "CHIUDI" : "AGGIUNGI DOCUMENTO"}/> */}
      <VisDiv>
      <VisDiv >
        <VisDiv style={{display:"flex", alignItems:"center", justifyContent:"centre"}} rules={[!file?._key]}>
          <h4>AGGIUNGI PDF</h4>
          <button onClick={handleClick} style={{backgroundColor:"green", marginLeft:"10px", marginRight:"10px"}} className='round-red-button'>
              <FaFilePdf
              size={22}
              color={"white"}
              />  
            <input
              type="file"
              name="upload-file"
              ref={hiddenFileInput}
              style={{display:"none"}}
              onChange={(e)=>uploadPdfFile(e)}
              className="insert-photo-button"
              />
          </button>
        </VisDiv>
        <VisDiv rules={[file?._key]}>
          <div style={{textAlign:"left", marginTop:"20px"}}>
            <h4>TITOLO</h4>
            <TextField 
                value={title} 
                onChange={(e) => setTitle(e.target.value)} 
                //description={"Questo dato non sarà inserito nell'offerta, serve per trovare il prodotto. Inserire un nome per creare un nuovo prodotto o per duplicare uno esistente. IL PREZZO DI LISTINO NON VERRA' DUPLICATO"} 
                //descriptionDivider={false}
            />
          </div>
          <div style={{textAlign:"left"}}>
            <h4>CATEGORIE</h4>
          </div>
          <FieldDropdown
              isSearchable="isSearchable"
              placeHolder={"Seleziona categorie"}
              isMulti={true}
              options={pdfCategories}
              initialValue={categories}
              onChange={(value) => { 
                setCategories(value)
              }}
          />
{/*           <div style={{textAlign:"left"}}>
            <h4>REGISTRI</h4>
          </div> 
          <FieldDropdown
              isSearchable="isSearchable"
              placeHolder={"Seleziona registri"}
              isMulti={true}
              options={templateRegistersData?.map?.((register)=>({...register, value:register.family, label: register.family}))?.sort(sortByLabel)}
              initialValue={templateRegisters}
              onChange={(value) => { 
                  setTemplateRegisters(value)
              }}  
          /> */}
{/*           <VisDiv rules={[templateRegisters?.length>0]}>
            <div style={{textAlign:"left"}}>
              <h4>PRESIDI</h4>
            </div>
            <FieldDropdown
                isSearchable="isSearchable"
                placeHolder={"Seleziona Presidi"}
                isMulti={true}
                options={presidioModulesOptions?.map?.((item)=>({...item, value:item.label}))?.sort(sortByLabel)}
                initialValue={deviceTemplates}
                onChange={(value) => { 
                    setDeviceTemplates(value)
                }}
              />
          </VisDiv> */}
{/*           <div style={{textAlign:"left"}}>
            <h4>TAGS</h4>
          </div>
          <FieldDropdownFree
              isSearchable="isSearchable"
              placeHolder={"Seleziona Tag"}
              isMulti={true}
              options={tagsOptions?.sort(sortByLabel)}
              initialValue={tags}
              onChange={(value) => { 
                  setTags(value)
              }}
            /> */}
          <VisDiv>
            <div>
              <button type="button" style={{backgroundColor: file?._key ? "green" : "grey"}} className="btn" onClick={()=>savePdf()} disabled={!file?._key} >SALVA</button>
            </div>
          </VisDiv>
          </VisDiv>
        </VisDiv>
      </VisDiv>
    </div>
  )
}

export default PdfFilesManagement

/* export const pdfUrl = ({assetId}) => {
      if(!assetId) return ""
      const match = assetId?.match(/file-([a-f0-9]{40})-pdf/);
      const projectId = process.env.NEXT_PUBLIC_PROJECT_ID
      const buildUrl = `https://cdn.sanity.io/files/${projectId}/production/${match}.pdf`
      return  buildUrl
} */